export default __webpack_public_path__ + "static/media/reactnative.4a4e7dd8.png";